<div class="contacts">

  <h2>
    Доставка
  </h2>
  <div class="delivery-inner">

    <div class="item">
      <div class="info-header uppercase">Почтой</div>

      <div class="delivery-info">

        <img src="../../../assets/icons/post-delivery.png" class="media-icon">
        <div class="info" [innerHTML]="deliveryMailInfo"></div>

      </div>
    </div>
    <div class="item">
      <div class="info-header uppercase">Забрать в магазине</div>

      <div class="delivery-info">

        <img src="../../../assets/icons/home.png" class="media-icon">

        <div>
          <div>Вы можете заранее забронировать книги, и мы отложим их для вас в нашем магазине в часы его работы.</div>
          <div class="bold">VARËNKA</div>
          <div  [innerHTML]="shopAddress"></div>
          <div  [innerHTML]="worktime"></div>
        </div>
      </div>
    </div>

    <div class="item" [innerHTML]="courierDeliveryInfo">



    </div>
    <div class="item ">
      <div class="info-header">

        Мы также всегда готовы пойти вам навстречу и организовать самый удобный вариант доставки!
      </div>
    </div>
  </div>
  <h2>
    Часто задаваемые вопросы
  </h2>
  <div class="info" [innerHTML]="deliveryQuestions">



  </div>


</div>
